import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Partners from "../components/Partners";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <Services />
      <Partners />
      <Footer />
    </>
  );
}
